import { render, staticRenderFns } from "./product-nav.vue?vue&type=template&id=7151a77d&scoped=true&"
import script from "./product-nav.vue?vue&type=script&lang=js&"
export * from "./product-nav.vue?vue&type=script&lang=js&"
import style0 from "./product-nav.vue?vue&type=style&index=0&id=7151a77d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7151a77d",
  null
  
)

export default component.exports